import { render } from "./LinkInBio.vue?vue&type=template&id=7e0332e0"
import script from "./LinkInBio.vue?vue&type=script&lang=js"
export * from "./LinkInBio.vue?vue&type=script&lang=js"

import exportComponent from "/Volumes/works/main/ProfileSuite/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__